var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-card-timestamp"},[_vm._v("\n  Last updated on: "+_vm._s(_vm._f("formatDate")(this._props.timestamp))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }